import React from 'react';
import FormItem from '@/components/ui/FormItem';
import InputNumber from '@/components/ui/InputNumber';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function WorkersNumberFormItem({ fieldName = '', required = true }: Readonly<FormItemProps>): JSX.Element {
	return (
		<FormItem
			required={required}
			name={fieldName}
			label="Workers number"
			requiredMessage="Please enter a workers number"
		>
			<InputNumber placeholder="Enter a workers number" min={0} />
		</FormItem>
	);
}
